// https://marmelab.com/react-admin/CreateEdit.html#toolbar
// https://marmelab.com/react-admin/CreateEdit.html#the-simpleform-component
// https://marmelab.com/react-admin/Actions.html#the-simple-way

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push as pushAction } from 'connected-react-router';
import { regex, showNotification as showNotificationAction, SimpleForm, TextInput } from 'react-admin';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { AuthLayout } from './authStyles';
import SaveButtonWithoutIcon from '../../components/SaveButtonWithoutIcon';
import HiddenInput from '../../components/HiddenInput';
import { sendCustomApiRequest } from '../../dataProvider';
import { withStyles } from '@material-ui/core/styles';

export const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{10,}$/;
const validatePasswordRegex = regex(passwordRegex, 'Min. 10 characters, number, small and big letters.');
const validatePasswordFields = (allValues) => {
  const errors = {};
  if (allValues.repass !== allValues.pass) {
    errors.repass = ['Passwords doesn\'t match'];
  }
  if (!allValues.pass) {
    errors.pass = ['Please type new password'];
  }
  return errors;
};

const styles = () => ({
  toolbar: {
    padding: '16px',
  },
  button: {
    marginLeft: '10px',
  },
});

class ProvideNewPassword extends Component {
  handleSubmit = (record) => {
    const { push, showNotification } = this.props;

    sendCustomApiRequest(
      `/lost-password/reset/${record.passwordToken}`,
      {
        'fos_user_resetting_form[plainPassword][first]': record.pass,
        'fos_user_resetting_form[plainPassword][second]': record.repass,
        'fos_user_resetting_form[_token]': record.csrfToken,
      },
    ).then((res) => {
      if (res.status !== 200) {
        throw res.status;
      }
      showNotification('Password has been changed, please log in using new credentials');
      push('/login');
    })
      .catch((e) => {
        showNotification(`Error: There was a server error, please try again (${e})`, 'warning');
      });
  };

  render() {
    let recordWithTokens = {
      passwordToken: this.props.match.params.passwordToken,
      csrfToken: this.props.match.params.csrfToken,
    };

    return (
      <AuthLayout>
        <SimpleForm record={recordWithTokens} validate={validatePasswordFields} toolbar={<SimpleFormToolbar {...this.props} />}
          save={this.handleSubmit}>
          <Typography color="primary" variant="h6" gutterBottom>
            Create your password
          </Typography>
          <HiddenInput source="passwordToken"/>
          <HiddenInput source="csrfToken"/>
          <TextInput type="password" fullWidth source="pass" label="Enter password" validate={validatePasswordRegex}/>
          <TextInput type="password" fullWidth source="repass" label="Repeat password"/>
        </SimpleForm>
      </AuthLayout>
    );
  };
}

const SimpleFormToolbarMarkup = ({ classes, handleSubmitWithRedirect, ...props }) => (
  <div className={classes.toolbar}>
    <SaveButtonWithoutIcon
      handleSubmitWithRedirect={handleSubmitWithRedirect}
      label="Confirm"
      data-testid="new-password-confirm-button"
      submitOnEnter={true}
    />
    <Button className={classes.button} component={Link} to="/login">
      Cancel
    </Button>
  </div>
);

const SimpleFormToolbar = withStyles(styles)(SimpleFormToolbarMarkup);

export default connect(null, {
  showNotification: showNotificationAction,
  push: pushAction,
  passwordRegex: passwordRegex,
})(ProvideNewPassword);
